import { useAuthentication } from "./useAuthentication";

export const useApi = () => {
    const { reauthenticate } = useAuthentication();

    const executeApiOperation = async (operation) => {
        try {
            return await operation();;
        } catch (error) {
            if (error.cause?.status === 401) {
                //reauthenticate and re-attempt the operation
                await reauthenticate();
                return await operation();
            }
            else throw error;
        }
    }

    return { executeApiOperation }
}